import { useState } from "react";
import { Navigate } from "react-router-dom";
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Box, Typography, Button, TextField } from '@mui/material';
import { loadFavicon, resetFavicon } from '../utils/Favicon';
import { REST_API_BASE_URL, getInitialCriteria, encryption, getIv, getRegistrationData } from '../utils/utils';

function Registration() {
    const[registrationData, setRegistrationData] = useState(getRegistrationData());
    const [passwordCriteria, setPasswordCriteria] = useState(getInitialCriteria());
    const[success, setSuccess] = useState(false);
    const[error, setError] = useState(false);
    const[errorMessage, setErrorMessage] = useState("");
    const [iv,  setIv] = useState(getIv());

    function validatePassword(password) {
        for(const c of password) {
            if(c >= 'a' && c <= 'z') {
                passwordCriteria.lowerCase++;
                setPasswordCriteria(passwordCriteria)
            } else if(c >= 'A' && c <= 'Z') {
                passwordCriteria.upperCase++;
                setPasswordCriteria(passwordCriteria);
            } else if(c >= '0' && c <= '9') {
                passwordCriteria.numeric++;
                setPasswordCriteria(passwordCriteria);
            } else {
                passwordCriteria.specialCharacter++;
                setPasswordCriteria(passwordCriteria);
            }

            passwordCriteria.length++;
            setPasswordCriteria(passwordCriteria);
        }

        console.log(passwordCriteria);
        
        let result = passwordCriteria.upperCase > 0 
        result = result && passwordCriteria.lowerCase > 0 
        result = result && passwordCriteria.numeric > 0
        result = result && passwordCriteria.specialCharacter > 0
        result = result && passwordCriteria.length > 8

        setPasswordCriteria(getInitialCriteria());
        console.log(result);
        return result;
    }

    function matchPassword(newPassword, confirmPassword) {
        let result = true;

        for(var i=0; i<newPassword.length && i<confirmPassword.length; i++) {
            if(newPassword[i] != confirmPassword[i]) {
                result = false;
                break;
            }
        }

        return result;
    }

    function isItEmpty() {
        let result = false;

        result = registrationData["email"].length === 0;
        result = result || registrationData["username"].length === 0;
        result = result || registrationData["key"].length === 0;

        return result;
    }

    function validate() {
        let result = true;

        if(isItEmpty()) {
            // setRegistrationData(getRegistrationData());
            setErrorMessage("Everty field must be filled.");
            setError(true);
            result = false;
        } else if(!validatePassword(registrationData["confirmPassword"])) {
            setRegistrationData((previousData) => ({ ...previousData, newPassword: "", confirmPassword: ""  }));
            setErrorMessage("Password did not fulfill the criteria.");
            setError(true);
            result = false;
        } else if(!matchPassword(registrationData["newPassword"], registrationData["confirmPassword"])) {
            setRegistrationData((previousData) => ({ ...previousData, newPassword: "", confirmPassword: ""  }));
            setErrorMessage("Password did not match.");
            setError(true);
            result = false;
        }

        return result;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setRegistrationData((previousData) => ({ ...previousData, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const proceed = validate();

        const data = {
            email: encryption(registrationData["email"], iv),
            username: encryption(registrationData["username"], iv),
            password: encryption(registrationData["confirmPassword"], iv),
            key: encryption(registrationData["key"], iv),
            iv: iv.toString(CryptoJS.enc.Base64)
        }

        if(proceed){ 
            loadFavicon();
            try {
                const response = await axios.post(
                    REST_API_BASE_URL + 'registration',
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                )

                console.log(response.data);
                setError(false);
                setSuccess(true);
            } catch(error) {
                console.error("Error submitting form:", error);
                switch(error.status) {
                    case 406:
                        setErrorMessage("User already exist.");
                        break;

                    case 500:
                        setErrorMessage("Server-side error, kindly try again later");
                        break;
                }
                setError(true);
            } finally {
                resetFavicon();
                setRegistrationData(getRegistrationData());
            }
        }
    };

    return(
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "50px",
                gap: "20px",
                paddingBottom: "20px"
            }}
        >
            {success? <Navigate to={"/login"} />  :
            <Box sx={{ width: "40%" }}>
                <Typography variant="h5" sx={{ color: "text.primary" }}>
                    Create a new account
                </Typography>
                <Typography variant="subtitle1" color="text.primary">
                    Password must satisfy the following criteria:
                </Typography>

                <Box sx={{ marginTop: "10px", marginLeft: "10px" }}>
                    <Typography variant="body2" color="text.secondary">
                        • Must be at least 9 characters long
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must contain at least 1 uppercase letter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must contain at least 1 lowercase letter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must include at least 1 numeric character
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must have at least 1 special character
                    </Typography>
                </Box>
                {error && <Box sx={{ marginTop: "10px", marginLeft: "10px" }}> 
                    <Typography variant="subtitle1" color="error">
                        {errorMessage}
                    </Typography>
                </Box> }
            </Box>}

            <Box
                component="form"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40%",
                    gap: "15px"
                }}
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit}
            >
                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="email"
                        label="Email"
                        name="email"
                        type="text"
                        value={registrationData["email"]}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="username"
                        label="Nav User Name"
                        name="username"
                        type="text"
                        value={registrationData["username"]}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="newPassword"
                        label="Password"
                        name="newPassword"
                        type="password"
                        value={registrationData["newPassword"]}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="confirmPassword"
                        label="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        value={registrationData["confirmPassword"]}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="key"
                        label="Web Access Key"
                        name="key"
                        type="text"
                        value={registrationData["key"]}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%", textAlign: "center", marginTop: "15px" }}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            width: "40%",
                            color: "white",
                            backgroundColor: "red",
                            "&:hover": { backgroundColor: "#8b0000" },
                        }}
                    >
                        Register
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default Registration;